import Component from '../abstracts/Component';
import vex from 'vex-js';
import Cookies from 'js-cookie';

export default class LoginPopupComponent extends Component {

  get COOKIE_NAME() {
    return {
      popUpHide: 'login_popup_hide',
      popupTooltipClose: 'login_popup_tooltip_close',
    };
  }

  get SELECTORS() {
    return {
      loginBalloon: '#loginTogglerButton',
      loginTooltipDialog: '[data-tooltip-container]',
      loginTooltipClose: '[data-tooltip-close]',
      loginPopup: '[data-login-popup]',
      loginWrapper: '[data-login-form-wrapper]',
      loginFormEmail: '#loginEmail',
    }
  }

  constructor(compEl) {
    super(compEl);
    this.loginBalloon = this.$component.querySelector(this.SELECTORS.loginBalloon);
    this.loginTooltipDialog = this.$component.querySelector(this.SELECTORS.loginTooltipDialog);
    this.loginTooltipClose = this.$component.querySelector(this.SELECTORS.loginTooltipClose);
    this.loginPopup = this.$component.querySelector(this.SELECTORS.loginPopup);
    this.loginWrapper = this.$component.querySelector(this.SELECTORS.loginWrapper);

    // timers
    this.loginPopupTimer = this.$component.dataset.loginPopupTimer * 1000;
    this.loginTooltipTimer = this.$component.dataset.loginTooltipTimer * 1000;
  }

  // VEX OPEN POPUP //
  openLoginPopUp() {
    const ctx = this;
    this.loginPopup.classList.remove("hidden");
    const modalContent = this.loginPopup;
    vex.open({
      unsafeContent: modalContent,
      showCloseButton: true,
      className: '--login-popup',
      closeClassName: 'icon close',
      afterOpen: function() {
        this.closeEl.classList.remove("vex-close");
        Cookies.set(ctx.COOKIE_NAME.popUpHide);
        this.contentEl.querySelector(ctx.SELECTORS.loginFormEmail).focus();
      },
      afterClose: function() {
        ctx.startLoginBalloonTimer();
      },
    });
  }

  handleTextDialog() {
    this.loginTooltipDialog.addEventListener("click", event => {
      this.openLoginPopUp();
    });

    //when user closes the text dialog set cookie
    this.loginTooltipClose.addEventListener("click", event => {
      event.stopPropagation();
      Cookies.set(this.COOKIE_NAME.popupTooltipClose);
      this.loginTooltipDialog.classList.add("hidden");
    });
  }

  handleBalloonClick() {
    this.loginBalloon.addEventListener("click", event => {
      this.openLoginPopUp();
    });
  }

  startLoginPopupTimer() {
    if(!Cookies.get(this.COOKIE_NAME.popUpHide)) {
      setTimeout(() => {
         this.openLoginPopUp();
      }, this.loginPopupTimer);
    } else {
      this.startLoginBalloonTimer();
    }
  }

  startLoginBalloonTimer() {
    if(this.loginBalloon) {
      setTimeout(() => {
         this.loginBalloon.classList.remove("hidden");
         this.startLoginTooltipTimer();
      }, this.loginPopupTimer);
    }
  }

  startLoginTooltipTimer() {
    if(this.loginTooltipDialog && !Cookies.get(this.COOKIE_NAME.popupTooltipClose)) {
      setTimeout(() => {
         this.loginTooltipDialog.classList.remove("hidden");
      }, this.loginTooltipTimer);
    }
  }

  render() {
    // Check if there's the login error query parameter
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loginError = urlParams.get('loginerror');

    //error in the login modal, show it
    if (`${loginError}` === 'true') {
      this.openLoginPopUp();
    } else {
      this.startLoginPopupTimer();
    }
    this.handleTextDialog();
    this.handleBalloonClick();
  }
}
